module.exports = __webpack_public_path__ + "assets/img/teacher (40).747ca942.png";